<script>
import LocalStorageService from "@/services/LocalStorageService";
import LogoutIcon from "@/icons/LogoutIcon.vue";
const localStorageService = LocalStorageService.getService();

export default {
  name: "SidebarUserCard",
  components: { LogoutIcon },
  data() {
    return {
      showUserCard: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    userName() {
      return `${this.user.first_name} ${this.user.last_name}`;
    },
    userRole() {
      return this.user.scopes.join(", ");
    },
    totalMix() {
      return this.user?.file_time?.total_mix || 0;
    },
    totalMixHours() {
      return this.totalMix / 3600;
    },
    monthlyLimitHours() {
      return this.user?.time_limit || 0;
    },
    remainingTimeHours() {
      return Math.max(this.monthlyLimitHours - this.totalMixHours, 0);
    },
  },
  methods: {
    timeInHours(time) {
      return `${time.toFixed(2)} часов`;
    },
    logout() {
      localStorageService.clearToken();
      window.location.reload();
    },
  },
};
</script>

<template>
  <div v-if="user">
    <el-popover
      v-model="showUserCard"
      trigger="click"
      popper-class="user-avatar"
      placement="bottom-start"
      width="270"
    >
      <div
        class="text-sm p-3 border border-gray-200 rounded bg-gray-50 space-y-3"
      >
        <div>
          <div class="text-gray-600">Размечено в текущем месяце</div>
          <div class="text-lg font-semibold text-black">
            {{ timeInHours(totalMixHours) }}
          </div>
        </div>
        <div
          v-if="monthlyLimitHours > 0"
          class="border-t border-gray-200 pt-2.5 space-y-2"
        >
          <div>
            <div class="text-gray-600">Лимит</div>
            <div class="text-lg font-semibold text-black">
              {{ timeInHours(monthlyLimitHours) }}
            </div>
          </div>
          <div>
            <div class="text-gray-600">Осталось</div>
            <div
              class="text-lg font-semibold text-black"
              :class="{ 'text-red-500': remainingTimeHours === 0 }"
            >
              {{ timeInHours(remainingTimeHours) }}
            </div>
          </div>
        </div>
      </div>

      <div class="border-t pt-4 mt-4">
        <el-button type="danger" plain @click="logout" class="w-full">
          <LogoutIcon style="height: 16px; width: 16px; margin-right: 8px" />
          Выход
        </el-button>
      </div>
      <template #reference>
        <div class="flex items-center cursor-pointer">
          <el-avatar class="mr-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18px"
              height="20px"
              viewBox="0 0 24 24"
              fill="white"
            >
              <circle cx="12" cy="6" r="4" stroke="#fff" stroke-width="1.5" />
              <path
                d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                stroke="#fff"
                stroke-width="1.5"
              />
            </svg>
          </el-avatar>

          <div>
            {{ userName }} <br />
            <span class="text-xs text-gray-400 font-light">
              {{ userRole }}
            </span>
          </div>

          <i class="ml-1 el-icon-arrow-down"></i>
        </div>
      </template>
    </el-popover>
  </div>
</template>

<style scoped lang="scss"></style>
